var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.293 1.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-8.5 8.5a1 1 0 01-.39.242l-4.5 1.5a1 1 0 01-1.266-1.265l1.5-4.5a1 1 0 01.242-.391l8.5-8.5zM15.586 5L15 5.586 13.414 4 14 3.414 15.586 5zm-2 2L12 5.414 6.374 11.04l-.793 2.379 2.379-.793L13.586 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 18a1 1 0 100 2h18a1 1 0 100-2H1z"
  }))));
}

export default SvgIbPencil;